import React, { Component } from "react";
import { connect } from "react-redux";
import { setActiveModel } from "../../../state/actions";
import "./timeroptionstoggle.style.scss";

const TIMER_OPTIONS_TOGGLE_CLASS = "timer-options-toggle";

type Props = {
  height: number;
  toggleOverlay: () => void;
};
type States = {
  modelSelectClass: string;
};

class TimerOptionsToggle extends Component<Props, States> {
  modelSelect = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      modelSelectClass: "",
    };
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  render() {
    const { modelSelectClass } = this.state;

    return (
      <div className={`${TIMER_OPTIONS_TOGGLE_CLASS} ${modelSelectClass}`}>
        <span
          className={`${TIMER_OPTIONS_TOGGLE_CLASS}__outline`}
          onClick={() => this.props.toggleOverlay()}
        >
          Adjust Timer
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { activeModel } = state;
  return { activeModel };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setActiveModel: (payload) => dispatch(setActiveModel(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimerOptionsToggle);
